import { Component, input } from '@angular/core';

@Component({
  selector: 'app-success-card',
  templateUrl: './success-card.component.html',
  styleUrls: ['./success-card.component.scss'],
  standalone: false
})
export class SuccessCardComponent {

  title = input<string>('');
  subTitle = input<string>('');

  constructor() { }

}
